'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fireAnalyticsUiEvent = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _events = require('./events');

var _mapDataPayloadToContextPayload = require('./map-data-payload-to-context-payload');

var _mapDataPayloadToContextPayload2 = _interopRequireDefault(_mapDataPayloadToContextPayload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNotUndefined = function isNotUndefined(a) {
    return !(0, _isUndefined2.default)(a);
};

/**
 * Analytics web react 2.0
 */

var mapUiPayload = function mapUiPayload(payload) {
    var context = (0, _mapDataPayloadToContextPayload2.default)(payload);
    var actionSubjectId = payload.actionSubjectId;

    return (0, _pickBy2.default)((0, _extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        actionSubjectId: actionSubjectId
    }), isNotUndefined);
};

var fireAnalyticsUiEvent = exports.fireAnalyticsUiEvent = function fireAnalyticsUiEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, _extends3.default)({}, mapUiPayload(payload), { analyticsType: _events.UI_EVENT_TYPE })).fire();
};